import React from 'react';
import PropTypes from 'prop-types';

const VaccinationBlock = (props) => {
    const { title, vaccinations, children } = props;

    return (
        <div className="vaccination-tool-result" >
            <h2 className="vaccination-tool-result__title">{title}</h2>
            <div className="vaccination-tool-result__body">
                { vaccinations.length ? (
                    <div className="vaccination-tool-result__left">
                        {vaccinations.map((vaccination => (
                            <div className="vaccination-tool-result__item" key={vaccination.uid}>
                                <button
                                    className="vaccination-tool-result__more-link"
                                    onClick={() => props.onVaccinationClick(vaccination)}
                                >
                                    {vaccination.name}
                                </button>
                            </div>
                        )))}
                    </div>
                ) : '' }
                <div className="vaccination-tool-result__right">
                    {children}
                </div>
            </div>
        </div>
    );
};

VaccinationBlock.propTypes = {
    title: PropTypes.string,
    vaccinations: PropTypes.arrayOf(PropTypes.shape({
        uid: PropTypes.string,
        name: PropTypes.string,
        big: PropTypes.shape({
            description: PropTypes.string,
            infoLink: PropTypes.string,
        }),
    })),
    children: PropTypes.node,
    onVaccinationClick: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
};

VaccinationBlock.defaultProps = {
    title: '',
    vaccinations: [],
    children: null,
    onVaccinationClick: () => {},
};

export default VaccinationBlock;



// WEBPACK FOOTER //
// ./src/frontend/apps/VaccinationTool/VaccinationBlock.jsx